var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    {
      attrs: {
        title: _vm.title,
        "header-tag": "header",
        "footer-tag": "footer",
      },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c("h6", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [_vm._v(" "), _c("b-card-text", [_vm._v(_vm._s(_vm.text))])],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }